import { render, staticRenderFns } from "./ProfileConversation.vue?vue&type=template&id=70c48fe1&"
import script from "./ProfileConversation.vue?vue&type=script&lang=js&"
export * from "./ProfileConversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports